import { render, staticRenderFns } from "./AbstractSetting.vue?vue&type=template&id=010d4ad9&scoped=true&"
import script from "./AbstractSetting.vue?vue&type=script&lang=ts&"
export * from "./AbstractSetting.vue?vue&type=script&lang=ts&"
import style0 from "./AbstractSetting.vue?vue&type=style&index=0&id=010d4ad9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010d4ad9",
  null
  
)

export default component.exports